import { ColumnsType } from 'antd/lib/table';
import { Key } from 'antd/es/table/interface';
import { CustomerVehicleReduced } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import { getTableScrollX } from '@/utils/table';
import InfiniteTable from '../../InfiniteTable';

interface Props {
  isFetching: boolean;
  columns: ColumnsType<CustomerVehicleReduced>;
  vehicle: CustomerVehicleReduced[];
  selectedVehiclesKeys: Key[];
  handleVehiclesSelect: (values: Key[]) => void;
  noSelection?: boolean;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
}

const VehiclesTableModal: React.FC<Props> = ({
  isFetching,
  columns,
  vehicle,
  selectedVehiclesKeys,
  handleVehiclesSelect,
  noSelection,
  fetchNextPage,
  hasNextPage,
}) => {
  return (
    <InfiniteTable<CustomerVehicleReduced>
      columns={columns}
      dataSource={vehicle}
      loading={isFetching}
      className="scroll-table"
      rowKey={(row) => row.id}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      scroll={{ x: getTableScrollX(columns) }}
      pagination={false}
      rowSelection={
        !noSelection
          ? {
              selectedRowKeys: selectedVehiclesKeys,
              onChange: handleVehiclesSelect,
            }
          : undefined
      }
    />
  );
};

export default VehiclesTableModal;
